import { handleActions } from 'redux-actions';
import {
  ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE,
} from '../actions/types';

const defaultState = {
  categories: [
    {
      id: 'low-volt',
      name: 'allProducts.catLowVolt',
      subcategories: [
        {
          id: 'low-volt-1',
          image: null,
          name: 'allProducts.subcatLowVolt1',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-bassa-tensione/giunti-e-terminali-bassa-tensione-per-applicazioni-speciali/',
        },
        {
          id: 'low-volt-2',
          image: null,
          name: 'allProducts.subcatLowVolt2',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-bassa-tensione/giunti-e-terminali-bassa-tensione-per-applicazioni-speciali/',
        },
      ],
    },
    {
      id: 'mid-volt',
      name: 'allProducts.catMidVolt',
      subcategories: [
        {
          id: 'mid-volt-1',
          image: null,
          name: 'allProducts.subcatMidVolt1',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-media-tensione/giunti-per-cavi-media-tensione/',
        },
        {
          id: 'mid-volt-2',
          image: null,
          name: 'allProducts.subcatMidVolt2',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-media-tensione/terminali-per-cavi-media-tensione/',
        },
        {
          id: 'mid-volt-3',
          image: null,
          name: 'allProducts.subcatMidVolt3',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-media-tensione/giunti-e-terminali-per-impianti-eolici-e-fotovoltaici/',
        },
        {
          id: 'mid-volt-4',
          image: null,
          name: 'allProducts.subcatMidVolt4',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-media-tensione/collegamenti-in-cavo-unipolare/',
        },
      ],
    },
    {
      id: 'high-volt',
      name: 'allProducts.catHighVolt',
      subcategories: [
        {
          id: 'high-volt-1',
          image: null,
          name: 'allProducts.subcatHighVolt1',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-alta-tensione/giunti-termorestringenti-per-cavi-52-kv/',
        },
        {
          id: 'high-volt-2',
          image: null,
          name: 'allProducts.subcatHighVolt2',
          link: 'http://www.elconmegarad.com/categoria-prodotto/accessori-alta-tensione/terminali-termorestringenti-per-cavi-52-kv/',
        },
      ],
    },
    {
      id: 'printed',
      name: 'allProducts.catPrinted',
      subcategories: [
        {
          id: 'printed-1',
          image: null,
          name: 'allProducts.subcatPrinted1',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-std/',
        },
        {
          id: 'printed-2',
          image: null,
          name: 'allProducts.subcatPrinted2',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-a-parete-sottile/',
        },
        {
          id: 'printed-3',
          image: null,
          name: 'allProducts.subcatPrinted3',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-speciali-mt/',
        },
        {
          id: 'printed-4',
          image: null,
          name: 'allProducts.subcatPrinted4',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-per-applicazioni-speciali/',
        },
        {
          id: 'printed-5',
          image: null,
          name: 'allProducts.subcatPrinted5',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-per-applicazioni-automotive/',
        },
        {
          id: 'printed-6',
          image: null,
          name: 'allProducts.subcatPrinted6',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/guaine-termorestringenti-speciali-multistrato-mt/',
        },
        {
          id: 'printed-7',
          image: null,
          name: 'allProducts.subcatPrinted7',
          link: 'http://www.elconmegarad.com/categoria-prodotto/guaine-e-parti-stampate/parti-stampate-termorestringenti/',
        },
      ],
    },
    {
      id: 'tape',
      name: 'allProducts.catTape',
      subcategories: [
        {
          id: 'tape-1',
          image: null,
          name: 'allProducts.subcatTape1',
          link: 'http://www.elconmegarad.com/categoria-prodotto/componenti/mastici/',
        },
        {
          id: 'tape-2',
          image: null,
          name: 'allProducts.subcatTape2',
          link: 'http://www.elconmegarad.com/categoria-prodotto/componenti/nastri/',
        },
        {
          id: 'tape-3',
          image: null,
          name: 'allProducts.subcatTape3',
          link: 'http://www.elconmegarad.com/categoria-prodotto/componenti/resine/',
        },
      ],
    },
  ],
  currentFilter: null,
};

const reducerMap = {
  [ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE]: (state, action) => {
    const { filter } = action.payload;

    return Object.assign({}, state, { currentFilter: filter });
  },
};

export default handleActions(reducerMap, defaultState);



/** WEBPACK FOOTER **
 ** ./web/js/reducers/productsDirectory.js
 **/